import { useTranslation } from 'react-i18next'

import { CaretDoubleRightIcon } from '@phosphor-icons/react'

import { Button, Text } from '@reveni-io/reveni-ui'

import useSmartTrackingRequest from '@/common/hooks/useSmartTrackingRequest/useSmartTrackingRequest'
import { getBlockDefinitions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/helpers'

import BlocksSidebarSection from './BlocksSidebarSection/BlocksSidebarSection'
import SmartTrackingUpsell from './SmartTrackingUpsell/SmartTrackingUpsell'
import { getAdvancedBlockDefinitions, getEssentialBlockDefinitions } from './helpers'
import * as Styles from './styles'

const BlocksSidebar = ({ layout, smartTrackingEnabled, onAddBlock, onClose }) => {
  const { t } = useTranslation()
  const { smartTrackingRequested, requestSmartTracking, requestingSmartTracking } = useSmartTrackingRequest()

  const definitions = getBlockDefinitions()

  return (
    <Styles.Container>
      <Styles.Header>
        <Text type="bodyMMedium">{t('Bloques')}</Text>
        <Button variant="text" aria-label={t('Cerrar menú de bloques')} onClick={onClose}>
          <CaretDoubleRightIcon size={20} />
        </Button>
      </Styles.Header>
      <Styles.Body>
        <BlocksSidebarSection
          title={t('Bloques esenciales')}
          definitions={getEssentialBlockDefinitions(definitions)}
          layout={layout}
          onAddBlock={onAddBlock}
        />
        <BlocksSidebarSection
          title={t('Bloques avanzados')}
          definitions={getAdvancedBlockDefinitions(definitions)}
          layout={layout}
          locked={!smartTrackingEnabled}
          onAddBlock={onAddBlock}
        >
          {!smartTrackingEnabled && (
            <SmartTrackingUpsell
              requested={smartTrackingRequested}
              requesting={requestingSmartTracking}
              onRequest={requestSmartTracking}
            />
          )}
        </BlocksSidebarSection>
      </Styles.Body>
    </Styles.Container>
  )
}

export default BlocksSidebar
